import { MutationTree } from 'vuex'
import { IScheduleState } from '@/store/schedule'
import { Types, Store, Current, Type, Open } from '@/store/schedule/types'

const mutations: MutationTree<IScheduleState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.type]: (state, action: Type) => {
    state.type = action.payload
  },
  [Types.open]: (state, action: Open) => {
    state.open = action.payload
  },
  [Types.scrollTop]: (state, action) => {
    state.scrollTop = action.payload
  }
}

export default mutations
